<template>
  <div>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <CalendarPublisherModal
      :isShow="isPublisherShow"
      :calendar="selectedItem"
      @close="closePublisher"
    ></CalendarPublisherModal>
    <CalendarEditor
      :isShow="isEditorShow"
      :calendar="selectedItem"
      @close="closeEditor"
    ></CalendarEditor>
    <UploadModal
      :isShow="isUploadShow"
      :type="type"
      @close="
        isUploadShow = false;
        getCals();
      "
      @completed="
        isUploadShow = false;
        getCals();
      "
    ></UploadModal>
    <v-breadcrumbs
      :items="breadcrumbs"
      large
      style="padding-bottom: 0px"
    ></v-breadcrumbs>
    <v-data-table
      class="mt-2"
      style="width: 96%; margin-left: 2%"
      :headers="headers"
      :items="calList"
      :loading="isTableLoading"
      item-key="identity"
      :search="search"
      :options.sync="options"
      :server-items-length="totalItems"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Manage Calendars</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            class="mt-3"
            label="SEARCH"
            v-model="search"
            @change="getCals"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn class="mr-2" color="primary" @click="openCreateModal">
            <v-icon class="mr-2">mdi-plus</v-icon>NEW</v-btn
          ><v-btn color="primary" @click="openUploadModal">
            <v-icon class="mr-2">mdi-upload</v-icon>UPLOAD</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" @click="showDetails(item)" class="mr-2"
              >mdi-pencil</v-icon
            >
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" @click="download(item)" class="mr-2"
              >mdi-download</v-icon
            >
          </template>
          <span>Download</span>
        </v-tooltip>
        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" @click="publish(item)" class="mr-2"
              >mdi-export</v-icon
            >
          </template>
          <span>Publish</span>
        </v-tooltip>
        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { calService } from "@/api/cal-service";
import CalendarEditor from "@/components/Modals/CalendarEditor";
import CalendarPublisherModal from "@/components/Modals/CalendarPublisherModal";
import UploadModal from "@/components/Modals/UploadModal";
import moment from "moment";
import { mapGetters } from 'vuex';


export default {
  name: "ManegeCalendar",
  components: { CalendarEditor, CalendarPublisherModal, UploadModal },
  computed:{
    ...mapGetters(['userProfile'])
  },
  data: () => {
    return {
      type: "calendar",
      isLoading: false,
      isTableLoading: false,
      isUploadShow: false,
      isPublisherShow: false,
      search: "",
      calList: [],
      totalItems: 0,
      options: {},
      isEditorShow: false,
      selectedItem: { identity: "", events: [] },
      headers: [
        // { text: "HostKey", value: "hostKey", width: "5%" },
        { text: "Name", value: "name", width: "20%", sortable:false },
        {
          text: "Description",
          value: "description",
          width: "25%",
          sortable: false,
        },
        { text: "Owner", value: "owner", width: "10%", sortable: false },
        {
          text: "Last Modified",
          value: "actionedBy",
          width: "10%",
          sortable: false,
        },
        {
          text: "Last Published",
          value: "publishedBy",
          width: "10%",
          sortable: false,
        },
        { text: "Actions", value: "actions", width: "10%", sortable: false },
      ],
      breadcrumbs: [
        {
          text: "< Home",
          href: "",
          disabled: false,
          href: "/",
        },
        {
          text: "Calendars",
          href: "",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    capitalizeFirstLetter(str) {
      if (str == "") return "";
      const capitalized = str[0].charAt(0).toUpperCase() + str[0].slice(1);
      return capitalized;
    },
    async init() {
      this.isLoading = true;
      this.calList = await calService.getCal(1, 10, "", "", "").result;
      this.isLoading = false;
    },
    async getCals() {
      this.selectedItem = { identity: "", events: [] };
      this.calList = [];
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.isTableLoading = true;
      let response = await calService.getCal(
        page,
        itemsPerPage,
        this.capitalizeFirstLetter(sortBy),
        sortDesc,
        this.search
      );
      if (response.total > 0) {
        this.totalItems = response.total;
        this.calList = response.result;
      }
      this.isTableLoading = false;
    },
    showDetails(item) {
      item.events.forEach((e) => {
        e.startDateTime = moment(e.startDateTime).format("yyyy-MM-DD");
        e.endDateTime = moment(e.endDateTime).format("yyyy-MM-DD");
      });
      this.selectedItem = item;
      this.isEditorShow = true;
    },
    async deleteItem(item) {
      let yes = confirm("Do you want to delete this calendar?");
      if (yes) {
        await calService.delCal(item.identity);
        this.getCals();
      }
    },
    openCreateModal() {
      this.isEditorShow = true;
    },
    openUploadModal() {
      this.isUploadShow = true;
    },
    closeEditor() {
      this.selectedItem = {};
      this.isEditorShow = false;
      this.getCals();
    },
    closePublisher() {
      this.selectedItem = {};
      this.isPublisherShow = false;
      this.getCals();
    },
    publish(item) {
      this.selectedItem = item;
      this.isPublisherShow = true;
    },
    download(item){
      let _url = process.env.VUE_APP_HOST +
          "api/calendar/"+item.identity+"/download"
      window.location = _url 
    },
    completedUpload() {
      let yes = confirm("Do you want to publish this calendar?");
      if (yes) {
        this.$router.push("cal-publisher");
      } else {
        this.getCals();
      }
    },
  },
  watch: {
    search(val) {
      //this.init();
    },
    options: {
      handler() {
        this.getCals();
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.userProfile || (!this.userProfile.isCalendarAdmin && !this.userProfile.isAdmin))
      this.$router.push('/')
    //this.init();
  },
};
</script>

<style>
</style>